import * as Sip from 'modules/Sip'
import { apiUWebRTCInfo } from 'modules/Api'
import * as C from './constants'

export const fetchCredentials = () => async (dispatch) => {
  const response = await dispatch({
    type: C.FETCH_CREDENTIALS,
    async payload() {
      return apiUWebRTCInfo()
    },
  })

  return Promise.resolve(response.value)
}

export const createConfig = () => {
  return async (dispatch, getState) => {
    const { UA_STUN_URLS } = getState().config.ua

    dispatch({
      type: C.CREATE_CONFIG_SESSION_OPTIONS,
      payload: UA_STUN_URLS,
    })

    await dispatch({
      type: C.CREATE_CONFIG,
      async payload() {
        return Sip.createConfig()
      },
    })

    return Promise.resolve()
  }
}

export const createUserAgent = () => ({
  type: C.CREATE_USER_AGENT,
  async payload() {
    return Sip.createUserAgent()
  },
})

export const userAgentRegistrationFailed = () => ({
  type: C.REGISTER_USER_AGENT_REJECTED,
})
